export default [
  {
    title: 'تولید محتوا با AI',
    icon: 'bx bx-bot',
    route: { name: 'ai' },
    resource: 'AiManager',
    action: 'show',
  },
]
